<form [formGroup]="form" class="cemento-product-section">
  <p>
    Selecciona el producto que quieres comprar
  </p>
  <div class="cemento-product-section__field">
    <app-product-card-select
      formControlName="product"
      [products]="products()"
      [selectionDelayMs]="1000">
    </app-product-card-select>
    @if (form.get('product')?.invalid && form.get('product')?.touched) {
      <div class="invalid-feedback d-block">Por favor, seleccione un producto.</div>
    }
  </div>
</form>
